import React, { Component } from 'react';

export default class Layout extends Component {

}

import Header from './Header';
Layout.Header = Header;
import Main from './Main';
Layout.Main = Main;
import Content from './Content';
Layout.Content = Content;
